import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";

function ProtectedRoute() {
  const isTokenAvailable = localStorage.getItem("jwt");

  const { auth } = useSelector((store) => store);
  const [isLoggedIn, setisLoggedIn] = useState(false);
  useEffect(() => {
    if (auth.user) {
      setisLoggedIn(true);
    }
  }, [auth]);
  return isLoggedIn || isTokenAvailable ? <Outlet /> : <Navigate to="/" />;
}

export default ProtectedRoute;
